(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["grid-density-controls"] && !Shopify.designMode) return;
  try {
    // Safety net: if the results-list view transition aborts (hidden tab,
  // rapid toggling), apply the picked grid view directly so the toggle
  // never silently no-ops.
  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement)) return;
    if (input.name !== 'grid' && input.name !== 'grid-mobile') return;
    const list = input.closest('results-list');
    const grid = list && list.querySelector('[ref="grid"]');
    if (!grid) return;
    const value = input.value;
    setTimeout(() => {
      if (input.checked && grid.getAttribute('product-grid-view') !== value) {
        grid.setAttribute('product-grid-view', value);
        try {
          const viewport = window.innerWidth >= 750 ? 'desktop' : 'mobile';
          sessionStorage.setItem('product-grid-view-' + viewport, value);
        } catch (e) {
          /* storage unavailable */
        }
      }
    }, 450);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["price-filter"] && !Shopify.designMode) return;
  try {
    class ValorenPriceSlider extends HTMLElement {
    connectedCallback() {
      this.minRange = this.querySelector('[ref="minRange"]');
      this.maxRange = this.querySelector('[ref="maxRange"]');
      this.fill = this.querySelector('[ref="fill"]');
      this.readout = this.querySelector('[ref="readout"]');
      const facet = this.closest('price-facet-component');
      this.minText = facet && facet.querySelector('[ref="minInput"]');
      this.maxText = facet && facet.querySelector('[ref="maxInput"]');
      if (!this.minRange || !this.maxRange) return;

      this.minRange.addEventListener('input', () => this.onDrag('min'));
      this.maxRange.addEventListener('input', () => this.onDrag('max'));
      this.minRange.addEventListener('change', () => this.commit());
      this.maxRange.addEventListener('change', () => this.commit());
      this.paint();
    }

    values() {
      let lo = parseInt(this.minRange.value, 10) || 0;
      let hi = parseInt(this.maxRange.value, 10);
      const max = parseInt(this.dataset.max, 10) || 0;
      if (Number.isNaN(hi)) hi = max;
      return { lo: Math.min(lo, hi), hi: Math.max(lo, hi), max };
    }

    onDrag(which) {
      // keep handles from crossing
      const lo = parseInt(this.minRange.value, 10) || 0;
      const hi = parseInt(this.maxRange.value, 10) || 0;
      if (lo > hi) {
        if (which === 'min') this.minRange.value = String(hi);
        else this.maxRange.value = String(lo);
      }
      this.paint();
    }

    paint() {
      const { lo, hi, max } = this.values();
      if (this.fill && max > 0) {
        this.fill.style.left = (lo / max) * 100 + '%';
        this.fill.style.width = ((hi - lo) / max) * 100 + '%';
      }
      if (this.readout) {
        const cur = this.dataset.currency || '';
        this.readout.textContent = cur + ' ' + lo + ' – ' + cur + ' ' + hi;
      }
    }

    commit() {
      const { lo, hi, max } = this.values();
      if (this.minText) this.minText.value = lo > 0 ? String(lo) : '';
      if (this.maxText) this.maxText.value = hi < max ? String(hi) : '';
      const source = this.minText || this.maxText;
      if (source) source.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  if (!customElements.get('valoren-price-slider')) {
    customElements.define('valoren-price-slider', ValorenPriceSlider);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["valoren-fav-button"] && !Shopify.designMode) return;
  try {
    (() => {
    const KEY = 'valoren:favorites';

    const readFavs = () => {
      try {
        const v = JSON.parse(localStorage.getItem(KEY) || '[]');
        return Array.isArray(v) ? v : [];
      } catch (e) {
        return [];
      }
    };

    const writeFavs = (list) => {
      try {
        localStorage.setItem(KEY, JSON.stringify(list));
      } catch (e) {
        /* storage unavailable */
      }
      document.dispatchEvent(new CustomEvent('valoren:favorites:changed'));
    };

    class ValorenFavButton extends HTMLElement {
      connectedCallback() {
        this.btn = this.querySelector('.valoren-fav__btn');
        if (!this.btn) return;
        this.btn.addEventListener('click', this.toggle);
        this.sync();
        document.addEventListener('valoren:favorites:changed', this.sync);
      }

      disconnectedCallback() {
        document.removeEventListener('valoren:favorites:changed', this.sync);
      }

      resolveHandle() {
        if (this.dataset.context === 'modal') {
          const link = document.querySelector(
            '#quick-add-modal-content .view-product-title a[href*="/products/"]'
          );
          const m = link && link.getAttribute('href').match(/\/products\/([a-z0-9-]+)/);
          return m ? m[1] : null;
        }
        return this.dataset.handle || null;
      }

      sync = () => {
        const handle = this.resolveHandle();
        const active = !!handle && readFavs().includes(handle);
        this.btn.setAttribute('aria-pressed', active ? 'true' : 'false');
        this.btn.setAttribute(
          'aria-label',
          active ? 'Fjern fra favoritter' : 'Tilføj til favoritter'
        );
      };

      toggle = (event) => {
        event.preventDefault();
        event.stopPropagation();
        const handle = this.resolveHandle();
        if (!handle) return;
        let favs = readFavs();
        if (favs.includes(handle)) {
          favs = favs.filter((h) => h !== handle);
        } else {
          favs = [handle, ...favs].slice(0, 100);
          this.btn.setAttribute('data-pop', 'true');
          setTimeout(() => this.btn.removeAttribute('data-pop'), 400);
        }
        writeFavs(favs);
      };
    }

    if (!customElements.get('valoren-fav-button')) {
      customElements.define('valoren-fav-button', ValorenFavButton);
    }

    // Header heart link: keeps its count badge in sync with the favorites list.
    class ValorenFavLink extends HTMLElement {
      connectedCallback() {
        this.badge = this.querySelector('[ref="badge"]');
        this.update();
        document.addEventListener('valoren:favorites:changed', this.update);
      }

      disconnectedCallback() {
        document.removeEventListener('valoren:favorites:changed', this.update);
      }

      update = () => {
        if (!this.badge) return;
        const n = readFavs().length;
        this.badge.textContent = n > 9 ? '9+' : String(n);
        this.badge.hidden = n === 0;
      };
    }

    if (!customElements.get('valoren-fav-link')) {
      customElements.define('valoren-fav-link', ValorenFavLink);
    }

    // Modal context: whenever the quick-add dialog content changes, re-sync the
    // heart and point the "Se hele produktet" footer link at the product.
    const syncModalExtras = () => {
      document.dispatchEvent(new CustomEvent('valoren:favorites:changed'));
      const link = document.getElementById('quick-add-full-link');
      if (!link) return;
      const titleLink = document.querySelector(
        '#quick-add-modal-content .view-product-title a[href*="/products/"]'
      );
      if (titleLink) {
        link.href = titleLink.getAttribute('href').split('#')[0];
        link.hidden = false;
      } else {
        link.hidden = true;
      }
    };
    const target = document.getElementById('quick-add-modal-content');
    if (target) new MutationObserver(syncModalExtras).observe(target, { childList: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
